import { pageURLs } from "@/constants";
import { queueGuide } from "@/components/GuidedSpotlight";

export const TOGETHER_STEPS = [
  {
    target: "#opt-anchor-location",
    title: "Where should the property be?",
    body: "Type a city or ZIP, then choose a radius, pick ZIP codes, or draw the exact area on the map.",
  },
  {
    target: "#opt-anchor-basics",
    title: "What kind of property?",
    body: "Pick the property type. The rest of the form opens once you do.",
    waitFor: "Pick a property type above to keep going.",
  },
  {
    target: "#opt-anchor-details",
    title: "The must-haves",
    body: "Beds, baths and size. Keep this to what's truly required. Anything flexible goes in nice-to-haves.",
  },
  {
    target: ".multi-select-outerwrap",
    title: "Nice-to-haves",
    body: "Pick everything that would be a plus, up to 25, from lot and interior features to community amenities. The more you add, the better we can match it across your network.",
  },
  {
    target: "#opt-anchor-budget",
    title: "Budget and financing",
    body: "A realistic price range brings better matches, and financing helps listing agents see a serious, ready buyer.",
  },
  {
    target: "#opt-anchor-polish",
    title: "Title and description",
    body: "A clear title, then write it like a for-sale listing for the buy side: the area, the lifestyle, every detail that matters and deal specifics like a rate buydown, closing timeline or compensation. Fair housing guardrails keep it compliant as you write.",
  },
  {
    target: ".edit-want-ad-btnwrap",
    title: "Publish it",
    body: "Confirm publishes it to every member of your network in the Feed. We match it against active and coming-soon for-sale listings and alert you when one fits.",
  },
];

export const startTogether = (navigate) => {
  queueGuide({
    path: pageURLs.agentCreatewantad,
    label: "Publish it together",
    index: 0,
    steps: TOGETHER_STEPS,
  });
  window.scrollTo({ top: 0 });
  navigate(pageURLs.agentCreatewantad);
};
